export const baseUrl = "https://api.utirx.com";
// export const baseUrl = "http://localhost:1337";
